// extracted by css-extract-rspack-plugin
export default {"VerifiedIcon":"MarketplaceItem-module__VerifiedIcon__kD7Uy","Label":"MarketplaceItem-module__Label__mahEy"};